import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../firebase";

export const uploadFile = async (file, path) => {
  try {
    const storage = getStorage();
    const fileRef = ref(storage, `${path}/${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);
    return fileURL;
  } catch (error) {
    console.error("Error uploading file:", error);
    return null;
  }
};

export const uploadLogo = async (file, clientName) => {
  if (!file) return null;
  const fileExtension = file.name.split(".").pop();
  const fileName = `${clientName
    .split(" ")
    .join("")
    .toLowerCase()}.${fileExtension}`;
  const fileRef = ref(storage, `client-logos/${fileName}`);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
};

export const deleteFilesFromUrls = async (urls = []) => {
  if (!Array.isArray(urls) || urls.length === 0) return;

  const storage = getStorage();

  await Promise.all(
    urls.map(async (url) => {
      try {
        const decodedUrl = decodeURIComponent(url.split("?")[0]);
        const storagePath = decodedUrl.split("/o/")[1];
        const fullPath = storagePath.replace(/%2F/g, "/");

        const fileRef = ref(storage, fullPath);
        await deleteObject(fileRef);
      } catch (error) {
        console.warn("Failed to delete file:", error.message);
      }
    })
  );
};
